module.exports = {"welcome":"<strong>BEM-VINDO</strong> ao simulador NOWO","sellingPoint":"QUER CONHECER<br>A NOSSA OFERTA PARA:","beforeYouStart":"Antes de começar, escolha o serviço que pretende","validUntil":"Condições válidas até","start":"COMEÇAR","taxIncluded":"Os valores apresentados incluem IVA à taxa legal em vigor.","taxNotIncluded":"Aos valores apresentados acresce IVA à taxa legal em vigor."}


//////////////////
// WEBPACK FOOTER
// ./src/locale/pt/lobby.json
// module id = XYHz
// module chunks = 64